module.exports = __webpack_public_path__ + "img/Icons-36.0fef299d.svg";